import API_ENDPOINTS from '../config/apiConfig';
import { api } from './api';

const buildQuery = ({ orgId, locationId } = {}) => {
  const params = [];
  if (orgId) params.push(`orgId=${orgId}`);
  if (locationId) params.push(`locationId=${locationId}`);
  return params.length > 0 ? `?${params.join('&')}` : '';
};

export const getRevenueBasisGroups = async (filters = {}) => {
  try {
    const response = await api.get(`${API_ENDPOINTS.REVENUE_BASIS_GROUPS}${buildQuery(filters)}`);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching revenue basis groups:', error);
    return [];
  }
};

export const createRevenueBasisGroup = async (data) => {
  const response = await api.post(API_ENDPOINTS.REVENUE_BASIS_GROUPS, data);
  return response.data;
};

export const updateRevenueBasisGroup = async (id, data) => {
  const response = await api.put(`${API_ENDPOINTS.REVENUE_BASIS_GROUPS}/${id}`, data);
  return response.data;
};

export const deleteRevenueBasisGroup = async (id) => {
  await api.delete(`${API_ENDPOINTS.REVENUE_BASIS_GROUPS}/${id}`);
};
